export const MIN_SEASON = 1990;
export const MAX_SEASON = 2100;

const EXACT_SEASON_RE = /^[0-9]{4}$/;

export function parseSeason(value) {
  if (value == null || typeof value === 'boolean') return null;

  let season;
  if (typeof value === 'number') {
    if (!Number.isInteger(value)) return null;
    season = value;
  } else if (typeof value === 'string' && EXACT_SEASON_RE.test(value)) {
    season = Number(value);
  } else {
    return null;
  }

  return season >= MIN_SEASON && season <= MAX_SEASON ? season : null;
}

export function seasonQuery(value) {
  if (value == null) return '';
  const season = parseSeason(value);
  return season == null ? null : `?season=${season}`;
}
